let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fVpZs")).then(() => parcelRequire('8Pg2Y'));